const defaultColumns = [{
    name: 'Total Fee',
    key: 'totalFee',
    format: '$',
    withCents: true,
}, {
    name: 'Referral',
    key: 'referral',
    format: '$',
}, {
    name: 'Credits',
    key: 'credits',
    format: '$',
}, {
    name: 'HSC Gross',
    key: 'hscGross',
    format: '$',
    withCents: true,
}, {
    name: 'Cumulative',
    key: 'cumulative',
    format: '$',
    withCents: true,
}, {
    name: 'Agent Net',
    key: 'agentNet',
    format: '$',
    withCents: true,
}, {
    name: 'HSC Net',
    key: 'hscNet',
    format: '$',
    withCents: true,
}];

export const totalColumns = [
    {
        name: '',
        key: 'title',
        class: 'PipelineTable_align_left',
    },
    ...defaultColumns,
];

export const columns = [
    {
        name: 'Date',
        key: 'date',
        format: 'date',
    }, {
        name: 'Property - City, State',
        key: 'property',
    },
    ...defaultColumns,
    {
        name: 'Referred by',
        key: 'referredBy',
    }
];